import React, { useState } from 'react';
import { Modal, Button, Tabs } from 'antd';
import './privacypolicy.css'; 

const PrivacyPolicyModal = ({ isOpen, onClose, translations, currentLang }) => {
  const { TabPane } = Tabs;
  const privacyData = translations[currentLang]?.privacy_policy;
  const btn = translations[currentLang]?.common_btn;

  // Handle null or undefined privacy data
  if (!privacyData) {
    return null;
  }

  // Helper function to render content sections
  const renderSection = (section) => {
    if (!section) return null;
    
    return (
      <div className="privacy-section mb-4">
        {section.title && <h4 className="privacy-section-title mb-3">{section.title}</h4>}
        {section.intro && <p>{section.intro}</p>}
        {section.content && (
          typeof section.content === 'string' 
            ? <p>{section.content}</p>
            : section.content.map((item, i) => <p key={i}>{item}</p>)
        )}
        {section.items && (
          <ul className="privacy-list">
            {section.items.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        )}
      </div>
    );
  };

  // Render definition items
  // Render definition items
  const renderDefinitions = () => {
    const defs = privacyData.definitions;
    if (!defs) return null;
    
    return (
      <div className="privacy-section mb-4">
        <h4 className="privacy-section-title mb-3">{defs.title}</h4>
        <dl className="privacy-definitions">
          {defs.platform && (
            <>
              <dt className="font-weight-bold">{defs.platform_label || "Zory Platform"}</dt>
              <dd className="mb-2">{defs.platform}</dd>
            </>
          )}
          {defs.merchant && (
            <>
              <dt className="font-weight-bold">{defs.merchant_label || "Merchant"}</dt>
              <dd className="mb-2">{defs.merchant}</dd>
            </>
          )}
          {defs.ecommerce && (
            <>
              <dt className="font-weight-bold">{defs.ecommerce_label || "E-Commerce Store"}</dt>
              <dd className="mb-2">{defs.ecommerce}</dd>
            </>
          )}
          {defs.consumer && (
            <>
              <dt className="font-weight-bold">{defs.consumer_label || "Consumer"}</dt>
              <dd className="mb-2">{defs.consumer}</dd>
            </>
          )}
          {defs.user && (
            <>
              <dt className="font-weight-bold">{defs.user_label || "User"}</dt>
              <dd className="mb-2">{defs.user}</dd>
            </>
          )}
        </dl>
      </div>
    );
  };
  return (
    <Modal
      title={privacyData.title}
      open={isOpen}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          {btn?.close}
        </Button>
      ]}
      width={800}
      className={`privacy-policy-modal ${currentLang === 'ar' ? 'rtl-text' : ''}`}
    >
      <div className="privacy-policy-container">
        {privacyData.welcome && <p className="privacy-welcome mb-3">{privacyData.welcome}</p>}
        {privacyData.introduction && <p className="privacy-intro mb-4">{privacyData.introduction}</p>}
        
        {renderDefinitions()}
        {renderSection(privacyData.information_collected)}
        {renderSection(privacyData.information_sharing)}
        {renderSection(privacyData.data_confidentiality)}
        {renderSection(privacyData.information_usage)}
        {renderSection(privacyData.cookies)}
        {renderSection(privacyData.user_rights)}
        {renderSection(privacyData.third_party_links)}
      </div>
    </Modal>
  );
};

export default PrivacyPolicyModal;
